/*
 * Copyright (c) 2025 Sila Artificial Intelligence Research LLC
 * A DA Holding Ltd Company
 * All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 */

import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Simple layout wrapper - authentication has been removed.
 * All routes are accessible without login.
 */
const AuthInitializer: React.FC = () => {
  return (
    <div className="min-h-screen w-full">
      <Outlet />
    </div>
  );
};

export default AuthInitializer;
